const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            backgroundColor: {
                type: 'string',
            },
            borderRadius: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            borderWidth: {
                type: 'number',
            },
            height: {
                type: 'number',
            },
            paddingHorizontal: {
                type: 'number',
            },
            paddingVertical: {
                type: 'number',
            },
            textMarginVertical: {
                type: 'number',
            },
            textMarginHorizontal: {
                type: 'number',
            },
            textFontSize: {
                type: 'number',
            },
            textFontWeight: {
                type: 'string',
            },
            textColor: {
                type: 'string',
            },
            iconName: {
                type: 'string',
            },
            iconColor: {
                type: 'string',
            },
            iconWidth: {
                type: 'number',
            },
            iconHeight: {
                type: 'number',
            },
            iconMarginHorizontal: {
                type: 'number',
            },
            iconMarginVertical: {
                type: 'number',
            },
            iconMarginRight: {
                type: 'number',
            },
        },
        appearances: {
            solid: {
                default: true,
            },
            outline: {
                default: false,
            },
            ghost: {
                default: false,
            },
            tag: {
                default: false,
            },
        },
        variantGroups: {
            status: {
                primary: {
                    default: true,
                },
                success: {
                    default: false,
                },
                warning: {
                    default: false,
                },
                warningAlt: {
                    default: false,
                },
                danger: {
                    default: false,
                },
                dangerAlt: {
                    default: false,
                },
                dark: {
                    default: false,
                },
                brand: {
                    default: false,
                },
                neutral: {
                    default: false,
                },
                subtle: {
                    default: false,
                },
                flat: {
                    default: false,
                },
            },
            size: {
                medium: {
                    default: true,
                },
            },
        },
        states: {},
    },
    appearances: {
        solid: {
            mapping: {
                borderRadius: 200,
                height: 22,
            },
            variantGroups: {
                status: {
                    primary: {
                        backgroundColor: 'color-brand-compliment-100',
                        textColor: 'color-primary-500',
                        iconColor: 'color-primary-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    success: {
                        backgroundColor: 'color-success-100',
                        textColor: 'color-success-500',
                        iconColor: 'color-success-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    warning: {
                        backgroundColor: 'color-warning-100',
                        textColor: 'color-warning-500',
                        iconColor: 'color-warning-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    danger: {
                        backgroundColor: 'color-danger-100',
                        textColor: 'color-danger-500',
                        iconColor: 'color-danger-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    flat: {
                        backgroundColor: 'color-flat-300',
                        textColor: 'color-flat-500',
                        iconColor: 'color-flat-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    // [TODO]: Ask Thai to add Secondary/Subtle to status variants
                    dark: {
                        backgroundColor: 'color-brand-300',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    brand: {
                        backgroundColor: 'color-brand-300',
                        textColor: 'color-text-basic',
                        iconColor: 'color-brand-100',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    neutral: {
                        backgroundColor: 'color-neutral-300',
                        textColor: 'color-neutral-500',
                        iconColor: 'color-neutral-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                    subtle: {
                        backgroundColor: 'color-subtle-300',
                        textColor: 'color-subtle-500',
                        iconColor: 'color-subtle-500',
                        iconName: 'close-circle',
                        textFontWeight: 'bold',
                    },
                },
                size: {
                    medium: {
                        borderRadius: '$button-border-round',
                        textMarginHorizontal: 2,
                        textMarginVertical: 2,
                        paddingHorizontal: 8,
                        paddingVertical: 4,
                        textFontSize: 13,
                        textFontWeight: 'bold',
                        iconWidth: 18,
                        iconHeight: 18,
                        iconMarginVertical: 2,
                        // iconMarginHorizontal: 2,
                        iconMarginRight: 2,
                    },
                },
            },
        },
        tag: {
            mapping: {
                borderRadius: 2,
            },
            variantGroups: {
                status: {
                    primary: {
                        backgroundColor: 'color-primary-500',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    success: {
                        backgroundColor: 'color-success-500',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    warning: {
                        backgroundColor: 'color-warning-500',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    warningAlt: {
                        backgroundColor: '#FDECD6',
                        textColor: '#F5A133',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 600,
                    },
                    danger: {
                        backgroundColor: 'color-danger-500',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    dangerAlt: {
                        backgroundColor: '#FAEBEA',
                        textColor: 'color-danger-500',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 600,
                    },
                    dark: {
                        backgroundColor: 'color-dark-transparent-1000',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    neutral: {
                        backgroundColor: 'color-neutral-500',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    subtle: {
                        backgroundColor: 'color-subtle-500',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                    flat: {
                        backgroundColor: 'color-flat-700',
                        textColor: 'color-text-basic',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-bold-font-weight',
                    },
                },
                size: {
                    medium: {
                        borderRadius: 2,
                        textMarginHorizontal: 4,
                        textMarginVertical: 2,
                        paddingHorizontal: 0,
                        paddingVertical: 0,
                    },
                },
            },
        },
        outline: {
            mapping: {
                backgroundColor: 'transparent',
                textFontSize: 'text-caption-1-font-size',
                textFontWeight: 'text-caption-1-font-weight',
                borderColor: 'color-flat-400',
                borderRadius: 6,
                borderWidth: 1,
            },
            variantGroups: {
                status: {
                    primary: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                    success: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                    warning: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                    danger: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                    dark: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                    neutral: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                    subtle: {
                        backgroundColor: 'transparent',
                        textColor: 'color-flat-700',
                        iconColor: 'color-text-basic',
                        iconName: 'close-circle',
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                },
                size: {
                    medium: {
                        borderRadius: 4,
                        textMarginHorizontal: 0,
                        textMarginVertical: 0,
                        paddingHorizontal: 12,
                        paddingVertical: 18,
                        textFontWeight: 'text-caption-1-font-weight',
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAChip.theme.alucio.js.map